import React, { useEffect, useState } from "react";
import Table from "../../../components/Table/TablePaginationFromApi";
import { useSelector, useDispatch } from "react-redux";
import { getComapareMapped } from "../../../redux/actions/PartnerReportAction";

const TotalMappedList = (props) => {
    const dispatch = useDispatch();
    const { token, selectedMapping, filters } = props;
    const [perPage, setPerPage] = useState(10);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [column, setColumn] = useState();
    const [sortDirection, setSortDirection] = useState();
    const { compareMapped, loadingCompareMapped, total } = useSelector(
        (state) => ({
            compareMapped:
                state.partnerReportReducer.compareMapped?.hotels ?? [],
            total: state.partnerReportReducer.compareMapped?.total ?? 0,
            loadingCompareMapped:
                state.partnerReportReducer.loadingCompareMapped,
        })
    );

    const columns = [
        {
            id: "hotel_code",
            name: <div className="table-title">Partner Hotel Code</div>,
            cell: (e) => {
                return <>{e?.hotel_code}</>;
            },
            sortable: true,
        },
        {
            id: "inventory_hotel_code",
            name: <div className="table-title">Inventory Hotel Code</div>,
            cell: (e) => {
                return <>{e?.inventory_hotel_code}</>;
            },
            sortable: true,
        },
        {
            id: "hotel_name",
            name: <div className="table-title">Name</div>,
            cell: (e) => {
                return <>{e?.hotel_name}</>;
            },
            sortable: true,
        },

        {
            id: "city",
            name: <div className="table-title">City</div>,
            cell: (e) => {
                return <>{e?.city}</>;
            },
            sortable: true,
        },
        {
            id: "country",
            name: <div className="table-title">Country</div>,
            cell: (e) => {
                return <>{e?.country}</>;
            },
            sortable: true,
        },
        {
            id: "address",
            name: <div className="table-title">Address</div>,
            cell: (e) => {
                return <>{e?.address}</>;
            },
            sortable: true,
        },

        {
            id: "rank",
            name: <div className="table-title">Rank</div>,
            cell: (e) => {
                return <>{e?.rank}</>;
            },
            sortable: true,
        },
    ];

    const handlePageChange = (page) => {
        dispatch(
            getComapareMapped(
                token,
                selectedMapping?.value,
                page,
                perPage,
                filterText,
                filters,
                column,
                sortDirection
            )
        );
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        dispatch(
            getComapareMapped(
                token,
                selectedMapping?.value,
                page,
                newPerPage,
                filterText,
                filters,
                column,
                sortDirection
            )
        );
        setPerPage(newPerPage);
    };

    const handleSort = async (c, sortD) => {
        dispatch(
            getComapareMapped(
                token,
                selectedMapping?.value,
                1,
                10,
                filterText,
                filters,
                c?.id,
                sortD
            )
        );
        setColumn(c?.id);
        setSortDirection(sortD);
    };

    return (
        <div style={{ marginTop: "15px" }}>
            <Table
                data={compareMapped}
                columns={columns}
                totalRows={total}
                handlePageChange={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                progressPending={loadingCompareMapped}
                onFilter={() => {
                    setResetPaginationToggle(true);
                    dispatch(
                        getComapareMapped(
                            token,
                            selectedMapping?.value,
                            1,
                            perPage,
                            filterText,
                            filters
                        )
                    );
                }}
                filterValue={filterText}
                handleClearFilter={() => {
                    setFilterText("");
                    setResetPaginationToggle(true);
                    dispatch(getComapareMapped(token, 1, perPage, "", filters));
                }}
                onChange={(e) => {
                    setFilterText(e.target.value);
                    if (e.target.value === "") {
                        setResetPaginationToggle(true);
                        dispatch(
                            getComapareMapped(
                                token,
                                selectedMapping?.value,
                                1,
                                perPage,
                                "",
                                filters
                            )
                        );
                    }
                }}
                filter={true}
                resetPaginationToggle={resetPaginationToggle}
                onSort={handleSort}
                sortServer={true}
            />
        </div>
    );
};

export default TotalMappedList;
